export type PRODUCT_GROUP_NAMES = 'Medicare Advantage'
  | 'Medigap'
  | 'Prescription Drug Plan'
  | 'Whole Health Balance'
  | 'Medicare Supplement'
  | 'Individual'
  | 'Off-Exchange'
  | 'On-Exchange'
  | 'Wholecare'
  | 'DSNP'
  | 'Dental'
  | PRODUCT_GROUPS.BLUE_EDGE_BALANCE;

export type PRODUCT_GROUP_NAMES_INDIVIDUAL = 'Off-Exchange' | 'On-Exchange' | 'Dental' | PRODUCT_GROUPS.BLUE_EDGE_BALANCE;

export enum PRODUCT_GROUPS {
  MEDICARE_ADVANTAGE = 'Medicare Advantage',
  MEDIGAP = 'Medigap',
  PRESCRIPTION_DRUG_PLAN = 'Prescription Drug Plan',
  WHOLE_HEALTH_BALANCE = 'Whole Health Balance',
  MEDICARE_SUPPLEMENT = 'Medicare Supplement',
  OFF_EXCHANGE = 'Off-Exchange',
  DENTAL = 'Dental',
  BLUE_EDGE_BALANCE = 'BEB',
  ON_EXCHANGE = 'On-Exchange',
  /** @deprecated - moving to DSNP */
  WHOLECARE = 'Wholecare',
  DSNP = 'DSNP'
};

export const DRX_ENABLED_PRODUCT_GROUPS = [
  PRODUCT_GROUPS.MEDICARE_ADVANTAGE,
  PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN
];

export const SENIOR_PRODUCT_GROUPS = [
  PRODUCT_GROUPS.MEDICARE_ADVANTAGE,
  PRODUCT_GROUPS.MEDIGAP,
  PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN,
  PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE,
  PRODUCT_GROUPS.WHOLECARE,
  PRODUCT_GROUPS.DSNP
];

export const ALL_INDIVIDUAL_PRODUCT_GROUPS = [
  PRODUCT_GROUPS.ON_EXCHANGE.toUpperCase(),
  PRODUCT_GROUPS.OFF_EXCHANGE.toUpperCase(),
  PRODUCT_GROUPS.DENTAL.toUpperCase(),
  PRODUCT_GROUPS.BLUE_EDGE_BALANCE.toUpperCase(),
];

export const OFF_EXCHANGE_INDIVIDUAL_PRODUCT_GROUPS = [
  PRODUCT_GROUPS.OFF_EXCHANGE.toUpperCase(),
  PRODUCT_GROUPS.DENTAL.toUpperCase(),
  PRODUCT_GROUPS.BLUE_EDGE_BALANCE.toUpperCase(),
];

export enum PRODUCT_TYPES {
  MEDICARE_ADVANTAGE = 'MA',
  MEDIGAP = 'MG',
  PRESCRIPTION_DRUG_PLAN = 'PDP',
  WHOLE_HEALTH_BALANCE = 'WHB',
  DSNP = 'DSNP',
  OFF_EXCHANGE = 'OFF_EXCHANGE',
  DENTAL = 'DENTAL',
  BLUE_EDGE_BALANCE = 'BEB',
  MA_PLAN_CHANGE = 'MA_PLAN_CHANGE',
  MG_PLAN_CHANGE = 'MG_PLAN_CHANGE',
  PLAN_CHANGE_SUFFX = '_PLAN_CHANGE',
  SIMPLIFIED_SUFFIX = '_SIMPLIFIED'
};

export const PRODUCT_TYPE_TO_GROUP_MAP = {
  [PRODUCT_TYPES.MEDICARE_ADVANTAGE]: PRODUCT_GROUPS.MEDICARE_ADVANTAGE,
  [PRODUCT_TYPES.MEDIGAP]: PRODUCT_GROUPS.MEDIGAP,
  [PRODUCT_TYPES.PRESCRIPTION_DRUG_PLAN]: PRODUCT_GROUPS.PRESCRIPTION_DRUG_PLAN,
  [PRODUCT_TYPES.WHOLE_HEALTH_BALANCE]: PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE,
  [PRODUCT_TYPES.OFF_EXCHANGE]: PRODUCT_GROUPS.OFF_EXCHANGE,
  [PRODUCT_TYPES.DENTAL]: PRODUCT_GROUPS.DENTAL,
  [PRODUCT_TYPES.BLUE_EDGE_BALANCE]: PRODUCT_GROUPS.BLUE_EDGE_BALANCE,
  [PRODUCT_TYPES.MA_PLAN_CHANGE]: 'MA Plan Change',
  [PRODUCT_TYPES.MG_PLAN_CHANGE]: 'MG Plan Change'
};